import React from "react";
import { useI18n } from "../../i18n";

/** Park the current basket or clear it — shared by the panel and the sheet. */
const TicketActions = ({ disabled, onHold, onClear }) => {
  const { t } = useI18n();

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onHold}
        disabled={disabled}
        className="h-9 px-3 rounded-lg bg-slate-800 border border-slate-700 text-xs font-bold text-slate-200 hover:bg-slate-700 disabled:opacity-40 active:scale-95 transition-all whitespace-nowrap"
      >
        {t("pos.ticket.hold")}
      </button>
      <button
        type="button"
        onClick={onClear}
        disabled={disabled}
        className="h-9 px-3 rounded-lg bg-slate-800 border border-slate-700 text-xs font-bold text-slate-300 hover:bg-red-600/80 hover:text-white hover:border-red-500 disabled:opacity-40 active:scale-95 transition-all whitespace-nowrap"
      >
        {t("pos.ticket.clear")}
      </button>
    </div>
  );
};

export default TicketActions;
